import { twMerge } from "tailwind-merge";
import React, { ReactElement, ReactNode } from "react";
import { useSellarUser } from "../../hooks";
import { useSellarCurrentBusiness } from "../../hooks/useSellarCurrentBusiness.shared";
import { Button, Card, H5, Icon } from "@sellar-io/components";
import { SellarWhiteLogoPurpleLogo } from "../sellarLogos/SellarWhiteLogoPurpleBackground";

export function IncompleteListUiContainer({
  title,
  description,
  children,
}: {
  title: string;
  description: string;
  children?: ReactNode;
}) {
  return (
    <Card
      className={twMerge("bg-white", "border border-zinc-300 bg-zinc-50 p-4")}
    >
      <div className="flex flex-row">
        <div className={"mr-4"}>
          <SellarWhiteLogoPurpleLogo />
        </div>
        <div className="flex flex-col gap-2">
          <div className="flex flex-col">
            <H5>{title}</H5>
            <p>{description}</p>
          </div>
          {children}
        </div>
      </div>
    </Card>
  );
}
export function IncompleteListUi({
  supplierName,
}: {
  supplierName?: string;
}): ReactElement | null {
  const { user } = useSellarUser();
  const { business } = useSellarCurrentBusiness();
  if (!business?.Retailer) return null;

  const defaultFormValue = "xxxxx";
  const userEmail = user?.email;
  const url = [
    "https://sellar.typeform.com/to/DR4AqbpI#",
    "supplier_name=",
    supplierName ? supplierName : defaultFormValue,
    "&retailer_name=",
    business.name,
    "&user_email=",
    userEmail ? userEmail : defaultFormValue,
  ]
    .filter(Boolean)
    .join("");
  return (
    <IncompleteListUiContainer
      title={"Something missing?"}
      description={
        "Let us know if you can't find a product that you think should be listed here."
      }
    >
      <Button
        onClick={() => window.open(url, "_blank")}
        color={"tertiary"}
        className={"pl-0 text-blue-700"}
      >
        <Icon icon={"OPEN_IN_NEW"} />
        Let us know
      </Button>
    </IncompleteListUiContainer>
  );
}
